import { managerEndpoints } from "@src/services/endpoints";
import { queryClient } from "@src/utils/queryClient";
import {
  USER_COOKIE,
  ROLE_COOKIE,
  STALE_TIME_1HS,
} from "@src/constants/constants";
import StorageUtils from "@src/utils/storageUtils";

const managerLoader = async () => {
  const currentUser = await StorageUtils.getObjectItemWithRetry(
    USER_COOKIE,
  ).catch((err) => {
    console.error("Failed to retrieve user:", err);
    return null; // treat errors as null
  });

  if (!currentUser?.roles?.includes("FUEL_MANAGER")) {
    console.warn("unauthorized");
    return null;
  }

  const manager = queryClient.ensureQueryData({
    queryKey: ["MANAGER_PROFILE", currentUser],
    staleTime: STALE_TIME_1HS,
    queryFn: async () => managerEndpoints.getManagerProfile(currentUser),
  });
  return manager;
};

export default managerLoader;
